/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { VatViewModel } from './VatViewModel';
import {
    VatViewModelFromJSON,
    VatViewModelFromJSONTyped,
    VatViewModelToJSON,
} from './VatViewModel';

/**
 * 
 * @export
 * @interface ResultOfVatViewModel
 */
export interface ResultOfVatViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfVatViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfVatViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfVatViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfVatViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfVatViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfVatViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfVatViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {VatViewModel}
     * @memberof ResultOfVatViewModel
     */
    data?: VatViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfVatViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfVatViewModel interface.
 */
export function instanceOfResultOfVatViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfVatViewModelFromJSON(json: any): ResultOfVatViewModel {
    return ResultOfVatViewModelFromJSONTyped(json, false);
}

export function ResultOfVatViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfVatViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : VatViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfVatViewModelToJSON(value?: ResultOfVatViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': VatViewModelToJSON(value.data),
        'Count': value.count,
    };
}

